import React, { useEffect } from "react";
import { Link } from "react-router-dom";

// Thank you page — SPANISH ONLY, per spec. Not wrapped in the localized layout.
export default function ThankYou() {
  useEffect(() => {
    document.title = "¡Gracias! · Xorzeni";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="header-solid text-white">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-4">
          <Link to="/" className="flex items-center gap-3 w-fit" data-testid="thankyou-header-logo">
            <span className="inline-flex items-center justify-center w-9 h-9 border border-white/40">
              <span className="font-serif-brand font-bold tracking-tight text-white text-lg">X</span>
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-serif-brand text-xl font-semibold tracking-tight">Xorzeni</span>
              <span className="font-mono-brand text-[10px] uppercase tracking-[0.22em] text-white/60">Recursos · AR</span>
            </span>
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center" data-testid="thankyou-page">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 py-24 text-center">
          <div className="font-mono-brand text-[11px] uppercase tracking-[0.24em] text-[var(--brand-terracotta)] mb-4">
            Confirmación · Xorzeni
          </div>
          <h1 className="font-serif-brand text-4xl sm:text-5xl lg:text-6xl text-[var(--brand-navy)] font-semibold mb-6">
            ¡Gracias por suscribirse!
          </h1>
          <p className="text-lg text-[var(--brand-ink)]/85 leading-relaxed mb-4">
            Hemos recibido correctamente sus datos. En los próximos días recibirá nuestro informe analítico semanal sobre el mercado argentino de recursos naturales: litio, petróleo, gas y minería.
          </p>
          <p className="text-sm text-[var(--brand-ink)]/65 mb-10">
            Revise su bandeja de entrada — el primer envío puede llegar a la carpeta de promociones.
          </p>
          <Link
            to="/"
            className="inline-flex items-center bg-[var(--brand-terracotta)] hover:bg-[var(--brand-terracotta-2)] text-white px-6 py-3 font-medium"
            data-testid="thankyou-back-home"
          >
            Volver al inicio
          </Link>
        </div>
      </main>

      <footer className="bg-[var(--brand-navy)] text-white/70 text-xs">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-2">
          <div>© {new Date().getFullYear()} Xorzeni Analytics S.A.S. — Todos los derechos reservados.</div>
          <div className="font-mono-brand tracking-[0.2em] uppercase">xorzeni.com · Argentina</div>
        </div>
      </footer>
    </div>
  );
}
